import { useEnableSerialNumberTrackingPhase2 } from '../feature-flags/hooks/use-enable-serial-number-tracking-phase-2';
import { useIsSerialNumberTrackingAvailable } from './use-is-serial-number-tracking-available';

export const useIsSerialNumberTrackingPhase2Available = (): boolean => {
  const { isAvailable } = useIsSerialNumberTrackingAvailable();
  const isFlagEnabled = useEnableSerialNumberTrackingPhase2();

  return isAvailable && isFlagEnabled;
};
